import { useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { Input } from "../../ui/input";
import { supabase } from "../../../lib/supabase";

const FIELDS = [
  ["branch", "Branch", "text"],
  ["representative_name", "Representative name", "text"],
  ["registration_date", "Registration date", "date"],
  ["registration_amount", "Registration amount (Rs.)", "number"],
];

export function OfficeDetails({ profileId, office, canEdit, onSaved }) {
  const [form, setForm] = useState(() => Object.fromEntries(FIELDS.map(([k]) => [k, office?.[k] ?? ""])));
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    const row = Object.fromEntries(Object.entries(form).map(([k, v]) => [k, v === "" ? null : v]));
    const { error } = await supabase.from("profile_office_details").upsert({ ...row, profile_id: profileId }, { onConflict: "profile_id" });
    setBusy(false);
    if (error) return toast.error(error.message);
    toast.success("Office details saved");
    onSaved();
  };
  return (
    <section className="rmm-card p-5 sm:p-6" data-testid="office-details">
      <h3 className="font-display text-2xl font-semibold text-[#7A0016]">Office use only</h3>
      <p className="mb-4 text-xs text-[#8C6A6C]">Never shown to clients.</p>
      <div className="grid gap-4 sm:grid-cols-2">
        {FIELDS.map(([k, label, type]) => (
          <label key={k} className="space-y-1.5 text-sm font-medium text-[#2C2424]">
            {label}
            <Input type={type} value={form[k]} disabled={!canEdit} onChange={(e) => setForm((f) => ({ ...f, [k]: e.target.value }))} data-testid={`office-${k}`} className="rmm-input h-10 bg-white" />
          </label>
        ))}
      </div>
      {canEdit && (
        <button type="button" onClick={save} disabled={busy} data-testid="office-save-button" className="mt-5 inline-flex items-center gap-2 rounded-full bg-[#7A0016] px-5 py-2 text-sm font-semibold text-[#F5E6BA] hover:bg-[#4A000E]">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Save office details
        </button>
      )}
    </section>
  );
}
